var is_home_page = false;

if (document.body.classList.contains('home')) {
  is_home_page = true;
}

var slides = document.getElementsByClassName('homeSlide');
var slideTimer = 5000;
var slideCounter = 0;

//add for sidebar screws

function slideHomePage() {
  slides[slideCounter].setAttribute('data-active', 'false');

  slideCounter++;
  if (slideCounter >= slides.length) {
    slideCounter = 0;
  }

  slides[slideCounter].setAttribute('data-active', 'true');

  window.setTimeout(function () {
    slideHomePage();
  }, slideTimer);
}

if (is_home_page) {
  window.setTimeout(function () {
    slideHomePage();
  }, slideTimer);
}
